import { render, staticRenderFns } from "./UDIscanCode.vue?vue&type=template&id=1de9c351&scoped=true"
import script from "./UDIscanCode.vue?vue&type=script&lang=js"
export * from "./UDIscanCode.vue?vue&type=script&lang=js"
import style0 from "./UDIscanCode.vue?vue&type=style&index=0&id=1de9c351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de9c351",
  null
  
)

export default component.exports